export const shortDate = (value: string) => {
  const date = new Date(value);
  const today = new Date();
  if (date.toDateString() === today.toDateString())
    return date.toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
    });
  return date.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
};
